import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4262c797"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notFound"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg",
  alt: "not found"
}, null, -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "iconElement"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "extra" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "datetime" }
const _hoisted_9 = {
  key: 0,
  class: "bottomBar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (!_ctx.list || _ctx.list.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, _toDisplayString(_ctx.emptyText), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_a_list, {
          class: "list",
          dataSource: _ctx.list
        }, {
          renderItem: _withCtx(({ item }) => [
            (_openBlock(), _createBlock(_component_a_list_item, {
              class: _normalizeClass({ item: true, read: item.read }),
              key: item.key,
              onClick: ($event: any) => (_ctx.handleClick(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_list_item_meta, { class: "meta" }, _createSlots({
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(item.title) + " ", 1),
                      _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "extra", _normalizeProps(_guardReactiveProps(item)), () => [
                          _createTextVNode(_toDisplayString(item.extra), 1)
                        ], true)
                      ])
                    ])
                  ]),
                  description: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.description), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.datetime), 1)
                    ])
                  ]),
                  _: 2
                }, [
                  (item.avatar)
                    ? {
                        name: "avatar",
                        fn: _withCtx(() => [
                          (typeof item.avatar === 'string')
                            ? (_openBlock(), _createBlock(_component_a_avatar, {
                                key: 0,
                                class: "avatar",
                                src: item.avatar
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.avatar), 1))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          ]),
          _: 3
        }, 8, ["dataSource"]),
        (_ctx.showClear || _ctx.showViewMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.showClear)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear')))
                  }, _toDisplayString(_ctx.clearText) + " " + _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              (_ctx.showViewMore)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('viewMore')))
                  }, _toDisplayString(_ctx.viewMoreText), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
}